export function isLegacyOSMClientId(clientId: string = '') {
  const strippedClientId = clientId.replace(/-/g, '').toLowerCase()

  const hexRegex = /^[0-9a-f]{32}$/i

  return hexRegex.test(strippedClientId)
}
